import { MoveLine } from './moves';
import { Stock } from './stock';
import { Warehouse } from './warehouses';

export interface WarehouseLocation<
    W extends Warehouse | undefined = any, // eslint-disable-line @typescript-eslint/no-explicit-any -- generic default requires any; unknown breaks structural assignability for optional type parameters
    ML extends MoveLine | undefined = any, // eslint-disable-line @typescript-eslint/no-explicit-any -- generic default requires any; unknown breaks structural assignability for optional type parameters
    S extends Stock | undefined = any, // eslint-disable-line @typescript-eslint/no-explicit-any -- generic default requires any; unknown breaks structural assignability for optional type parameters
> {
    /** @deprecated use uuid instead */
    id: number | null
    uuid: string
    warehouseId: number
    warehouseUuid: string
    warehouse: W
    name: string
    storageType: WarehouseLocationStorageType | null
    storageAddress: null | {
        aisle: string | null
        section: string | null
        level: string | null
        position: string | null
    }
    deletedAt: string | null
    moveLines: ML extends undefined ? undefined : ML[]
    stocks: S extends undefined ? undefined : S[]
}

export const validLocationStorageTypes = ['area', 'shelf', 'pallet', 'bin_small', 'bin_medium', 'bin_large', 'bin_xlarge'] as const;

export type WarehouseLocationStorageType = typeof validLocationStorageTypes[number];
